import { useContext, useEffect } from 'react';

import { SourceScreenName } from '../../../../hooks/events/useFundsEvents';
import { useRMVBalanceState } from '../../../../hooks/useBalanceState';
import { useRMVCurrency } from '../../../../hooks/useCurrency';

import BuyRMVControl from '../../../buyRMVControl/BuyRMVControl';
import ElementLoader, { ElementLoaderContext } from '../../../element-loader/ElementLoader';
import ValueAndIcon from '../../../generics/ValueAndIcon';
import MenuAccountDropdownAccountBadge from '../menuAccountDropdownAccountBadge/MenuAccountDropdownAccountBadge';
import styles from './MenuAccountDropdownBalanceSection.module.scss';

interface BalanceSectionProps {
  variant?: 'default' | 'referral';
}

const MenuAccountDropdownBalanceSectionBalance = ({ variant = 'default' }: BalanceSectionProps) => {
  const currencyRMV = useRMVCurrency();
  const { balance: rmvCurrencyBalance, loading: rmvCurrencyBalanceLoading } = useRMVBalanceState();
  const { enableUi, disableUi } = useContext(ElementLoaderContext);

  useEffect(() => {
    if (rmvCurrencyBalanceLoading) {
      disableUi();

      return;
    }

    enableUi();
  }, [rmvCurrencyBalanceLoading, enableUi, disableUi]);

  const captionClassNames = [
    styles['balance-section__caption'],
    variant === 'referral' ? styles['balance-section__caption--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  const listClassNames = [
    styles['balance-section__list'],
    variant === 'referral' ? styles['balance-section__list--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <p className={captionClassNames}>Your Balance</p>
      <ul className={listClassNames}>
        {currencyRMV && (
          <li>
            <ValueAndIcon
              iconSize={28}
              valueSize={variant === 'referral' ? 24 : 20}
              value={rmvCurrencyBalance || 0}
              icon={currencyRMV?.icon}
              iconAltText={currencyRMV?.symbol}
            />
          </li>
        )}
      </ul>
    </>
  );
};

const MenuAccountDropdownBalanceSection = ({ variant = 'default' }: BalanceSectionProps) => {
  const buyButtonClassNames = [
    styles['buy-rmv-control'],
    variant === 'referral' ? styles['buy-rmv-control--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  const accountBadgeClassNames = [
    styles['account-badge'],
    variant === 'referral' ? styles['account-badge--referral'] : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <div className={accountBadgeClassNames}>
        <MenuAccountDropdownAccountBadge variant={variant} />
      </div>
      <div className={styles['balance-section']}>
        <ElementLoader>
          <MenuAccountDropdownBalanceSectionBalance variant={variant} />
        </ElementLoader>
        <BuyRMVControl className={buyButtonClassNames} sourceScreen={SourceScreenName.UserDropdown} />
      </div>
    </>
  );
};

export default MenuAccountDropdownBalanceSection;
